import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-listing',
  templateUrl: './profile-listing.component.html',
  styleUrls: ['./profile-listing.component.css']
})
export class ProfileListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
